import { Box, Text } from '@chakra-ui/react';

interface Props {
	label: string
}

const CalendarEvent = ({ label }: Props) => {
	return (
		<Box>
			<Text>{label}</Text>
		</Box>
	);
}

export default CalendarEvent
